export default {
  state: {
    // 属性
    mmsiArray: [],
    mmsi: '',
    costMonth: '',
    aisShipList: [],
    currentShipData: {},
    selectedGoods: '',
    noAisShipList: [],
    aisPoint: undefined
  },
  getters: {
    mmsiArray: (state) => state.mmsiArray,
    mmsi: (state) => state.mmsi,
    costMonth: (state) => state.costMonth,
    aisShipList: (state) => state.aisShipList,
    currentShipData: (state) => state.currentShipData,
    selectedGoods: (state) => state.selectedGoods,
    noAisShipList: (state) => state.noAisShipList,
    aisPoint: (state) => state.aisPoint
  },
  mutations: {
    // set方法
    setMmsi(state, v) {
      state.mmsi = v;
    },
    // set方法
    setMmsiArray(state, v) {
      state.mmsiArray = v;
    },
    // set方法
    setCostMonth(state, v) {
      state.costMonth = v;
    },
    // set方法
    setAisShipList(state, v) {
      state.aisShipList = v;
    }, // set方法
    setNoAisShipList(state, v) {
      state.noAisShipList = v;
    },
    setCurrentShipData(state, v) {
      state.currentShipData = v;
    },
    setSelectedGoods(state, v) {
      state.selectedGoods = v;
    },
    setAisPoint(state, v) {
      state.aisPoint = v
    }
  },
  actions: {
    SET_MMSI_ARRAY({ commit }, value) {
      commit('setMmsiArray', value);
    },
    SET_MMSI({ commit }, value) {
      commit('setMmsi', value);
    },
    SET_COST_MONTH({ commit }, value) {
      commit('setCostMonth', value);
    },
    SET_AIS_SHIP_LIST({ commit }, value) {
      commit('setAisShipList', value);
    },
    SET_NO_AIS_SHIP_LIST({ commit }, value) {
      commit('setNoAisShipList', value);
    },
    SET_CURRENT_SHIP_DATA({ commit }, value) {
      commit('setCurrentShipData', value);
    },
    SET_SELECTED_GOODS({ commit }, value) {
      commit('setSelectedGoods', value);
    },
    SET_AIS_POINT({ commit }, value) {
      commit('setAisPoint', value);
    }
  },
};
